module.exports = __webpack_public_path__ + "img/skin-tight.26a45c06.png";